import { Tooltip } from "@mui/material";

const RoleTooltip = ({ title, placement = "bottom", disabled = false, children }) => {
  if (!title) {
    return children;
  }

  return (
    <Tooltip
      title={title}
      placement={placement}
      arrow
      enterDelay={180}
      leaveDelay={0}
      describeChild
      disableHoverListener={disabled}
      disableFocusListener={disabled}
      slotProps={{
        popper: {
          modifiers: [{ name: "offset", options: { offset: [0, 8] } }],
        },
        tooltip: { className: "sm-role-tooltip" },
        arrow: { className: "sm-role-tooltip-arrow" },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default RoleTooltip;
